import { create } from 'zustand';
import { LoginProvider } from '~/types';
import { saveAuthInfo, clearAuthInfo } from '~/utils/authStorage';

interface AuthState {
  isLoading: boolean;
  isInitialized: boolean;
  isAuthenticated: boolean;
  authProvider: 'firebase' | 'cognito' | null;
  loginMethod: LoginProvider | null;
  idToken: string | null;

  // 액션
  setAuthLoading: (loading: boolean) => void;
  setAuthInitialized: (initialized: boolean) => void;
  setLoginMethod: (loginMethod: LoginProvider | null) => void;
  setAuthProvider: (authProvider: 'firebase' | 'cognito' | null) => void;
  setAuthenticated: (email: string | null) => void;
  setIdToken: (token: string | null) => void;
  resetAuth: () => void;
}

const useAuthStore = create<AuthState>((set, get) => ({
  isLoading: true,
  isInitialized: false,
  isAuthenticated: false,
  authProvider: null,
  loginMethod: null,
  idToken: null,

  setAuthLoading: (loading) => set({ isLoading: loading }),
  setAuthInitialized: (initialized) => set({ isInitialized: initialized }),
  setAuthenticated: (email) => {
    const { authProvider, loginMethod } = get();
    // 인증 정보 로컬 스토리지에 저장
    if (authProvider) {
      saveAuthInfo({
        lastAuthProvider: authProvider,
        loginMethod: loginMethod || null,
        email: email || undefined,
        lastLoginAt: Date.now(),
      });

      set({
        isAuthenticated: true,
        authProvider: authProvider,
        loginMethod: loginMethod || null,
      });
    } else {
      clearAuthInfo();
      set({
        isAuthenticated: false,
        authProvider: null,
        loginMethod: null,
      });
    }
  },
  setIdToken: (token) => set({ idToken: token }),
  setLoginMethod: (loginMethod) => set({ loginMethod }),
  setAuthProvider: (authProvider) => set({ authProvider }),
  resetAuth: () => {
    clearAuthInfo();
    set({
      isAuthenticated: false,
      authProvider: null,
      loginMethod: null,
      idToken: null,
    });
  },
}));

export default useAuthStore;
